import {Component, Input, Output, EventEmitter} from '@angular/core';
import {Variation, VariationAssignment} from '@emm/common-items/models/variation.model';
import {Observable} from 'rxjs';

@Component({
    selector: 'emm-assignments-card',
    templateUrl: './assignments-card.component.html',
    styleUrls: ['./assignments-card.component.scss'],
    standalone: false
})
export class AssignmentsCardComponent {
    @Input() variation: Variation;
    @Input() assignments: VariationAssignment[];
    @Input() itemTag: string;
    @Input() hideButtons: boolean;
    @Input() isSuperAdmin: boolean;
    @Input() isLoading$: Observable<boolean>;

    @Output() createAssignment = new EventEmitter<void>();
    @Output() editAssignment = new EventEmitter<VariationAssignment>();

    formatPropertyKey(key: unknown): string {
        const keyStr = String(key);
        return keyStr.charAt(0).toUpperCase() + keyStr.slice(1).toLowerCase();
    }

    onCreateAssignment() {
        this.createAssignment.emit();
    }

    onEditAssignment(assignment: VariationAssignment) {
        this.editAssignment.emit(assignment);
    }
}
